module.exports = __webpack_public_path__ + "img/de.cc23f204.png";